var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVideoOff = function SvgVideoOff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.544,7.064l-9.76,9.725C4.3,16.511,4.001,15.995,4,15.437V8.564C4,7.7,4.695,7,5.574,7h8.524 C14.253,7,14.403,7.022,14.544,7.064z M15.672,9.798v5.64c0,0.862-0.695,1.562-1.574,1.562H8.445L15.672,9.798z M16.393,10.347 l2.979-2.17C19.719,7.925,20,8.079,20,8.505v6.31c0,0.433-0.307,0.634-0.713,0.438l-2.894-1.405 C16.393,13.848,16.393,10.347,16.393,10.347z M18.223,4.5l0.83,0.827L4.83,19.5L4,18.673L18.223,4.5z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVideoOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/video-off.9bce1da6.svg";
export { ForwardRef as ReactComponent };